import {
    sendMessageToParent,
    UWM_DETAILED_VIEW_STATE,
    UWM_INSIGHT_COLLAPSE,
    UWM_MODULE_BACK_BUTTON_CLICK,
    UWM_MODULE_DATA_RECEIVED_SUCCESS,
    UWM_MODULE_HIDE_MENU,
    UWM_MODULE_INITIALIZATION_ERROR,
    UWM_MODULE_LOADED,
    UWM_MODULE_RESIZE,
    UWM_MODULE_SCROLL,
    UWM_MODULE_SHOW_MENU,
    UWM_NAVIGATE_TO,
    UWM_OPTIMIZE_EXPERIENCE,
    UWM_SHOW_NOTIFICATION,
    UWM_TRACK_ANALYTICS,
} from '@uwm/host';
import log from '@uwm/logger';
import {UWM_MODULE_GET_EXTERNAL_LINKS} from '@/consts/uwmEventTypes';
import type {ExternalLinkExtendedModel} from '@/types/aem';

const UWM_MODULE_NAME = 'ORION_INSIGHTS_B';

interface ExternalLinkRequest {
    externalLink: ExternalLinkExtendedModel;
    formattedSsoTemplate: string | null;
}

const sendLoadedMessage = () => {
    sendMessageToParent({type: UWM_MODULE_LOADED, moduleName: UWM_MODULE_NAME});
};

const sendDataSuccessMessage = () => {
    sendMessageToParent({type: UWM_MODULE_DATA_RECEIVED_SUCCESS});
};

const sendInitializationError = (message: string) => {
    sendMessageToParent({type: UWM_MODULE_INITIALIZATION_ERROR, message});
    log.error(`[UWM] Initialization error: ${message}`);
};

const sendBackButtonClick = () => {
    sendMessageToParent({type: UWM_MODULE_BACK_BUTTON_CLICK});
};

const sendResizeMessage = (height: number) => {
    sendMessageToParent({type: UWM_MODULE_RESIZE, height});
};

const sendNavigateTo = (navigateType: string, extras?: Record<string, unknown>) => {
    sendMessageToParent({type: UWM_NAVIGATE_TO, navigateType, ...extras});
};

const sendOptimizeExperience = (insightId: string) => {
    sendMessageToParent({type: UWM_OPTIMIZE_EXPERIENCE, insightId});
};

const sendShowNotification = (notificationType: string) => {
    sendMessageToParent({type: UWM_SHOW_NOTIFICATION, notificationType, moduleName: UWM_MODULE_NAME});
};

const sendTrackAnalytics = (eventType: string, params?: Record<string, unknown>) => {
    sendMessageToParent({type: UWM_TRACK_ANALYTICS, eventType, params, moduleName: UWM_MODULE_NAME});
};

const sendInsightCollapse = () => {
    sendMessageToParent({type: UWM_INSIGHT_COLLAPSE});
};

const sendScrollMessage = (delta: number, scrollTop: number) => {
    sendMessageToParent({type: UWM_MODULE_SCROLL, delta, scrollTop});
};

const sendShowMenu = () => {
    sendMessageToParent({type: UWM_MODULE_SHOW_MENU});
};

const sendHideMenu = () => {
    sendMessageToParent({type: UWM_MODULE_HIDE_MENU});
};

const sendDetailedViewState = (value: boolean, insightId: string, modalType: string) => {
    sendMessageToParent({type: UWM_DETAILED_VIEW_STATE, value, insightId, modalType});
};

const sendGetExternalLinks = (externalLinks: ExternalLinkRequest[], isRefetch?: boolean) => {
    sendMessageToParent({type: UWM_MODULE_GET_EXTERNAL_LINKS, externalLinks, isRefetch});
};
export default {
    sendMessageToParent,
    sendLoadedMessage,
    sendDataSuccessMessage,
    sendInitializationError,
    sendBackButtonClick,
    sendResizeMessage,
    sendNavigateTo,
    sendOptimizeExperience,
    sendShowNotification,
    sendTrackAnalytics,
    sendInsightCollapse,
    sendScrollMessage,
    sendShowMenu,
    sendHideMenu,
    sendDetailedViewState,
    sendGetExternalLinks,
};
